import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=59a062ad&scoped=true"
var script = {}
import style0 from "./Simple.vue?vue&type=style&index=0&id=59a062ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a062ad",
  null
  
)

export default component.exports